import { ChevronDown, LogOut } from 'lucide-react'

import { useAdminUser } from '@/auth/auth-context'
import { Menu, MenuDivider, MenuItem, MenuLabel } from '@/components/ui/Menu'
import { cn } from '@/lib/cn'
import { signOut } from '@/services/auth'

/// Порт `AdminUserMenu`. `dark` — вариант для тёмного сайдбара.
export function UserMenu({ dark = false }: { dark?: boolean }) {
  const user = useAdminUser()
  const email = user.email ?? user.uid
  const initial = email ? email[0].toUpperCase() : '?'

  return (
    <Menu
      align={dark ? 'start' : 'end'}
      trigger={() => (
        <span className="flex max-w-full min-w-0 items-center gap-2 rounded-lg px-1 py-1">
          <span
            className={cn(
              'flex size-8 shrink-0 items-center justify-center rounded-full text-sm font-bold',
              dark ? 'bg-sidebar-selected text-sidebar-accent' : 'bg-brand/12 text-brand',
            )}
          >
            {initial}
          </span>
          <span
            className={cn(
              'hidden min-w-0 truncate text-[13px] sm:block',
              dark ? 'text-white' : 'text-ink',
            )}
          >
            {email}
          </span>
          <ChevronDown
            size={18}
            className={cn('shrink-0', dark ? 'text-sidebar-text-faint' : 'text-ink-muted')}
          />
        </span>
      )}
    >
      {({ close }) => (
        <>
          <MenuLabel>{email}</MenuLabel>
          <MenuDivider />
          <MenuItem
            icon={<LogOut size={18} />}
            onClick={() => {
              close()
              void signOut()
            }}
          >
            Выйти
          </MenuItem>
        </>
      )}
    </Menu>
  )
}
